<div class="table-container-pager">
    <div>
        <ng-content select="table-container-top"></ng-content>
    </div>
    <div *ngIf="showTable">
        <ng-content></ng-content>
    </div>
    <div class="row table-spinner" *ngIf="!showProgress && !showTable">
        <div class="col-48 no-result-message-container">
            <p class="font-weight-300 text-grey">{{ noResultMessage }}</p>
        </div>
    </div>
    <div class="clearfix table-container-paginate">
        <div *ngIf="showProgress" class="table-spinner">
            <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
        </div>

        <div class="d-flex align-items-center">
            <table-page-size
                *ngIf="onPerPageChange.observers.length > 0"
                [totalItems]="51"
                [pageSize]="getPageSize().toString()"
                (onPerPageChange)="handlePerPageChange($event)"
                class="mr-auto">
            </table-page-size>
            <div *ngIf="onPageChange.observers.length > 0"
                 class="table-pagination">
                <ul class="pager" role="menu">
                    <li role="menuitem"
                        [ngClass]="{disabled: noPrevious()}"
                        class="previous">
                        <a (click)="!noPrevious() && pageChange(page - 1); $event.preventDefault()"
                           [attr.disabled]="noPrevious() ? true : null"
                           role="button"
                           tabindex="0">
                            «
                        </a>
                    </li>
                    <li role="menuitem"
                        [ngClass]="{disabled: noNext()}"
                        class="next">
                        <a (click)="!noNext() && pageChange(page + 1); $event.preventDefault()"
                           [attr.disabled]="noNext() ? true : null"
                           role="button"
                           tabindex="0">
                            »
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
